const getValueForSize = (props, sizes) => sizes[props.size] || sizes.default;

export {
  getValueForSize, //eslint-disable-line
};
